import Components from '../../Components';
import {
  getIsAccessMember,
  getHasGlobalNetworkAddon,
  getIsVirtualMember,
} from '../../Core/Utils/userPermissions';
import { getWebsiteUrl } from '../../Core/Utils/linkGenerator';
import { OPEN_WORKSPACE_LANDING_PATH } from './constants';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: OPEN_WORKSPACE_LANDING_PATH,
  exact: true,
  name: 'navigation.menu.openWorkspace',
  private: true,
  type: containerTypes.SUBCONTENT,
  grouping: 'navigation.grouping.reserve',
  requiresMemberPortalAccess: true,
  isHardRedirect: true,
  isAuthorized: ({ profile }) => {
    return !getIsVirtualMember(profile);
  },
  externalUrl: ({ profile, userDefaultGrouping }) => {
    const isAccessMember = getIsAccessMember(profile);
    const hasGlobalNetworkAddon = getHasGlobalNetworkAddon(profile);
    const homeLocationId = userDefaultGrouping?.location?._id;
    if (isAccessMember && !hasGlobalNetworkAddon && homeLocationId != null) {
      return getWebsiteUrl(`coworking?locationObjectId=${homeLocationId}`);
    }
    return getWebsiteUrl('coworking');
  },
};

export default RouteConfig;
